<template>
  <div>
    <el-card shadow="always" body-style="padding:0px;width:100%;">
      <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="chart_lxdz_1_introduce" class="text-introduce" style="position: relative">
              <img
                id="changelist"
                :src="'/static/list_ico.png'"
                alt=""
                style="position: absolute; top: 44px; right: 30px" />
              <h3>连续型电子出版物统计</h3>
              <p>
                <span class="numStyle">{{ nParOrgCount }}</span> 个省局，
                <span class="numStyle">{{ nOrgCount }}</span> 家出版单位，
                <span class="numStyle">{{ nLxdzCount }}</span> 种连续型电子出版物
              </p>
              <p v-for="(item, index) in groupData">
                {{ item.organizationname }}
                <span class="numStyle">{{ item.materialtitle }}</span> 家，共
                <span class="numStyle">{{ item.materialcode }}</span> 种
              </p>
            </div>
            <div id="chart_lxdz_1_table" class="echart_table">
              <table id="chart_lxdz_1_tab" class="tabletemp table-striped table-bordered tabletemp-hover">
                <thead>
                  <tr title="返回">
                    <th style="width: 60px">
                      <div class="th-inner" @click="backEcharts()">
                        <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
                      </div>
                      <div class="fht-cell"></div>
                    </th>
                    <th nowrap="nowrap" style="padding: 0.74rem; width: 160px">
                      <div class="th-inner text-warning">省局</div>
                      <div class="fht-cell">
                        <el-input
                          v-if="queryVisible"
                          v-model="query.provincename"
                          clearable
                          size="mini"
                          placeholder="请输入内容"
                          class="searchInput">
                          <el-button
                            @click="goFilterList()"
                            slot="append"
                            size="mini"
                            icon="el-icon-search"></el-button>
                        </el-input>
                      </div>
                    </th>
                    <th nowrap="nowrap" style="padding: 0.74rem; width: 220px">
                      <div class="th-inner text-warning">出版单位</div>
                      <div class="fht-cell">
                        <el-input
                          v-if="queryVisible"
                          v-model="query.name"
                          clearable
                          size="mini"
                          placeholder="请输入内容"
                          class="searchInput">
                          <el-button
                            @click="goFilterList()"
                            slot="append"
                            size="mini"
                            icon="el-icon-search"></el-button>
                        </el-input>
                      </div>
                    </th>
                    <th nowrap="nowrap">
                      <div class="th-inner text-warning">
                        连续型电子出版物数量
                        <i
                          @click="setQueryVisible()"
                          class="fa fa-filter searchFilerCls"
                          aria-hidden="true"
                          title="筛选"
                          style="margin-right: 5px" />
                        <i
                          @click="downloadData('chart_lxdz_1_html')"
                          class="fa fa-download searchFilerCls"
                          aria-hidden="true"
                          title="导出" />
                      </div>
                      <div class="fht-cell">
                        <el-input
                          v-if="queryVisible"
                          v-model="query.value"
                          clearable
                          size="mini"
                          placeholder="请输入内容"
                          class="searchInput">
                          <el-button
                            @click="goFilterList()"
                            slot="append"
                            size="mini"
                            icon="el-icon-search"></el-button>
                        </el-input>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody id="chart_lxdz_1_html" style="font-size: 14px !important">
                  <tr>
                    <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="chart_lxdz_1" style="height: 484.5px; width: 100%; padding-top: 20px; margin-bottom: 40px"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="first_finance_pie_chart_sale" style="height: 300px"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="first_finance_pie_chart_pay" style="height: 300px"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="second_finance_pie_chart_sale" style="height: 300px"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="always" body-style="padding:0px;width:100%;">
            <div id="second_finance_pie_chart_pay" style="height: 300px"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");

import { getLxdzInfo, getLxdzDetail } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: "2023",
      category: "音像",
      datalist: [],
      filtedData: [],

      queryVisible: false,
      query: {
        provincename: "",
        name: "",
        value: "",
      },

      nLxdzCount: 0,
      nOrgCount: 0,
      nParOrgCount: 0,
      groupData: [],
      pieInfo: {},
    };
  },
  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler(val) {
        this.chartTheme = val;
        console.log("lxdzfinace====", val);
        if (this.activeName == "lxdzfinace") {
          this.goSearchBusinessCharts();
        }
      },
      immediate: true,
    },
    activeName: {
      handler(val) {
        console.log("lxdzfinace====", val);
        if (val == "lxdzfinace") {
          var myChart = echarts.init(document.getElementById("chart_lxdz_1"), this.chartTheme);
          this.chartResize(myChart);
          var ffpcsChart = echarts.init(document.getElementById("first_finance_pie_chart_sale"), this.chartTheme);
          this.chartResize(ffpcsChart);
          var ffpcpChart = echarts.init(document.getElementById("first_finance_pie_chart_pay"), this.chartTheme);
          this.chartResize(ffpcpChart);
          var sfpcsChart = echarts.init(document.getElementById("second_finance_pie_chart_sale"), this.chartTheme);
          this.chartResize(sfpcsChart);
          var sfpcpChart = echarts.init(document.getElementById("second_finance_pie_chart_pay"), this.chartTheme);
          this.chartResize(sfpcpChart);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async downloadData(id) {
      var columns = { provincename: "省局", name: "出版单位", value: "连续型电子出版物数量" };
      var changeName = { provincename: "organizationname", name: "materialtitle", value: "materialcode" };

      let cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
      var list = [];
      console.log("datalist==", this.datalist);
      for (var i in this.datalist) {
        var po = this.datalist[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[changeName[key]];
        }
        list.push(data);
      }
      var filename = `${this.targetyear}年连续型电子出版物详细_${moment()}.xlsx`;
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
    initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      let html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html +=
          ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' +
          (Number(index) + 1) +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 160px;padding: 0.74rem;">' +
          item.organizationname +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 220px;padding: 0.74rem;">' +
          item.materialtitle +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' +
          this.formatEmpty(item.materialcode) +
          "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts() {
      var years = [2021, 2022, 2023, 2024];
      var that = this;

      getLxdzInfo({ firstyear: this.searchFirstYear }).then((res) => {
        console.log("getLxdzInfo====", res);
        that.nLxdzCount = res.lxdzCount;
        that.nOrgCount = res.orgCount;
        that.nParOrgCount = res.parOrgCount;
        that.groupData = res.groupData;
        that.pieInfo = res.pieInfo[0];

        // echat对象
        var lineNames = [];
        var seriesList = [];
        // 数据
        var lineBase = {};
        if (res.base.length > 0) {
          lineNames.push("年度销售收入");
          lineNames.push("年度利润总额");
          // 一般是两组 音像一组 电子一组
          for (var record of res.base) {
            if (record["firstyear"] % 2 == 0) {
              // 有几组以偶数年份开头的错误数据
              continue;
            }

            // 年份数据
            var firstdata = [];
            firstdata.push(record["firstsales"]);
            firstdata.push(record["firstprofit"]);
            lineBase[record["firstyear"]] = firstdata;

            var seconddata = [];
            seconddata.push(record["secondsales"]);
            seconddata.push(record["secondprofit"]);
            lineBase[record["secondyear"]] = seconddata;
          }
        }
        console.log("lineBase==", lineBase);
        Object.keys(lineNames).forEach((item) => {
          var dataList = [];
          if (lineNames[item] == "年度销售收入") {
            for (var year of years) {
              dataList.push((lineBase[year][0] * 1).toFixed(2));
            }
          } else if (lineNames[item] == "年度利润总额") {
            for (var year of years) {
              dataList.push((lineBase[year][1] * 1).toFixed(2));
            }
          }

          var series = {
            name: lineNames[item],
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {},
              },
            },
            emphasis: {
              focus: "series",
            },
            data: dataList,
          };
          seriesList.push(series);
        });

        var chartParams = {
          title: "连续型电子出版物经营数据统计",
          // subtext: "单位数量：" + res.count,
          names: lineNames,
          years: years,
          series: seriesList,
        };

        setTimeout(function () {
          that.drawChartLine("chart_lxdz_1", chartParams);
          that.draw2DPieChart();
        }, 1000);
      });
    },
    drawChartLine: function (id, chartParams) {
      console.log("drawChartLine", id, chartParams);
      let that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 10,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 10,
          data: chartParams.names,
        },
        xAxis: {
          type: "category",
          data: chartParams.years,
        },
        yAxis: {
          type: "value",
          name: "万元",
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "数据列表", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };

      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);

      document.getElementById("changelist").addEventListener("click", (e) => {
        getLxdzDetail({
          firstyear: this.searchFirstYear,
        }).then((res) => {
          console.log("getLxdzDetail====", res);
          that.datalist = res.data;
          that.filtedData = res.data;
          that.backEcharts();
          that.createDataHtml(id, res.data);
        });
      });
    },
    draw2DPieChart: function () {
      console.log(this.pieInfo);
      this.disposeChart("first_finance_pie_chart_sale");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_sale"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年连续型电子出版物出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: (this.pieInfo.firstsales1 * 1).toFixed(2), name: "国内发行" },
              { value: (this.pieInfo.firstsales2 * 1).toFixed(2), name: "海外发行" },
              { value: (this.pieInfo.firstsales3 * 1).toFixed(2), name: "出让版权" },
              { value: (this.pieInfo.firstsales4 * 1).toFixed(2), name: "出版活动" },
              { value: (this.pieInfo.firstsales5 * 1).toFixed(2), name: "网站广告" },
              { value: (this.pieInfo.firstsales6 * 1).toFixed(2), name: "审校加工" },
              { value: (this.pieInfo.firstsales7 * 1).toFixed(2), name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("first_finance_pie_chart_pay");
      var myChart2 = echarts.init(document.getElementById("first_finance_pie_chart_pay"), this.chartTheme);
      var option2 = {
        title: {
          text: "2023年连续型电子出版物支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: (this.pieInfo.firstpay1 * 1).toFixed(2), name: "团队人员成本" },
              { value: (this.pieInfo.firstpay2 * 1).toFixed(2), name: "运营成本" },
              { value: (this.pieInfo.firstpay3 * 1).toFixed(2), name: "审校劳务支出" },
              { value: (this.pieInfo.firstpay4 * 1).toFixed(2), name: "印刷压盘包装" },
              { value: (this.pieInfo.firstpay5 * 1).toFixed(2), name: "新媒体上的投入" },
              { value: (this.pieInfo.firstpay6 * 1).toFixed(2), name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("second_finance_pie_chart_sale");
      var myChart3 = echarts.init(document.getElementById("second_finance_pie_chart_sale"), this.chartTheme);
      var option3 = {
        title: {
          text: "2024年连续型电子出版物出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: (this.pieInfo.secondsales1 * 1).toFixed(2), name: "国内发行" },
              { value: (this.pieInfo.secondsales2 * 1).toFixed(2), name: "海外发行" },
              { value: (this.pieInfo.secondsales3 * 1).toFixed(2), name: "出让版权" },
              { value: (this.pieInfo.secondsales4 * 1).toFixed(2), name: "出版活动" },
              { value: (this.pieInfo.secondsales5 * 1).toFixed(2), name: "网站广告" },
              { value: (this.pieInfo.secondsales6 * 1).toFixed(2), name: "审校加工" },
              { value: (this.pieInfo.secondsales7 * 1).toFixed(2), name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_pay");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_pay"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年连续型电子出版物支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: (this.pieInfo.secondpay1 * 1).toFixed(2), name: "团队人员成本" },
              { value: (this.pieInfo.secondpay2 * 1).toFixed(2), name: "运营成本" },
              { value: (this.pieInfo.secondpay3 * 1).toFixed(2), name: "审校劳务支出" },
              { value: (this.pieInfo.secondpay4 * 1).toFixed(2), name: "印刷压盘包装" },
              { value: (this.pieInfo.secondpay5 * 1).toFixed(2), name: "新媒体上的投入" },
              { value: (this.pieInfo.secondpay6 * 1).toFixed(2), name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },
    chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts() {
      var disb = $("#chart_lxdz_1_introduce").css("display");
      console.log("disb==", disb);
      if (disb == "none") {
        $("#chart_lxdz_1_introduce").fadeIn(500);
        $("#chart_lxdz_1_table").css("width", $("chart_lxdz_1_table").width());
        $("#chart_lxdz_1_table").css("display", "none");
      } else {
        $("#chart_lxdz_1_introduce").css("display", "none");
        $("#chart_lxdz_1_table").fadeIn(500);
      }
    },
    clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible() {
      this.queryVisible = !this.queryVisible;
    },
    goFilterList() {
      console.log("goFilterList", this.query);
      this.filtedData = this.datalist.filter((item) => {
        return (
          item.organizationname.indexOf(this.query.provincename) > -1 &&
          item.materialtitle.indexOf(this.query.name) > -1 &&
          (item.materialcode + "").indexOf(this.query.value) > -1
        );
      });
      this.createDataHtml("chart_lxdz_1", this.filtedData);
    },
    formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
  },
  created: function () {
    let that = this;
    window.addEventListener("resize", () => {
      that.initCharts();
    });
    that.initCharts();
  },
};
</script>

<style lang="scss" scoped>
.echart_table {
  height: 484.5px;
  width: 100%;
  overflow: hidden;
  display: none;
}

.echart_table table tbody {
  display: block;
  height: 484.5px;
  overflow-y: auto;
}

.searchFilerCls {
  float: right;
  padding-top: 3px;
  margin-left: 10px;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}

.th-inner {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// LxdzFinance.vue?88b7b2b6